import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`inscripciones/${id}`));
  },
  async findAllPorPrograma(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones/programa'), { params: opciones.params });
  },
  async findAllPorProgramaUniversidad(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones/programa-universidad'), { params: opciones.params });
  },
  async findAllPorProgramaUniversidadVerificacion(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones/programa-universidad-verificacion'), {
      params: opciones.params,
    });
  },
  async findAllPorProgramaSede(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones/programa-sede'), { params: opciones.params });
  },
  async findAllPorProgramaSedeVerificacion(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones/programa-sede-verificacion'), {
      params: opciones.params,
    });
  },
  async findConHistorialEstadosAcademicos(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`inscripciones/${id}/historial-estados-academicos`), {
      params: opciones.params,
    });
  },
};
